// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_tech_quote_title = /** @type {(inputs: {}) => string} */ () => {
	return `Specialist in Trauma Surgery & Sports Traumatology`
};

const el_tech_quote_title = /** @type {(inputs: {}) => string} */ () => {
	return `Ειδικός Χειρουργικής Τραυμάτων & Αθλητικής Τραυματιολογίας`
};

const ru_tech_quote_title = /** @type {(inputs: {}) => string} */ () => {
	return `Специалист по травматологии и спортивной травматологии`
};

const he_tech_quote_title = /** @type {(inputs: {}) => string} */ () => {
	return `מומחה לכירורגיית טראומה ורפואת ספורט`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tech_quote_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tech_quote_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("tech_quote_title", locale)
	if (locale === "en") return en_tech_quote_title(inputs)
	if (locale === "el") return el_tech_quote_title(inputs)
	if (locale === "ru") return ru_tech_quote_title(inputs)
	if (locale === "he") return he_tech_quote_title(inputs)
	return "tech_quote_title"
};